module.exports = __webpack_public_path__ + "static/img/rh-icon.6092bda6.svg";